import { apiClient } from "services/api";
import type {
  ClientCharacteristic,
  CreateCharacteristicPayload,
  UpdateCharacteristicPayload,
} from "types/domain";

/**
 * GET /api/v0.0.3/client-characteristics
 * Fetches all client characteristics for the current account.
 */
export async function fetchClientCharacteristics(): Promise<ClientCharacteristic[]> {
  const response = await apiClient.get<{ data: ClientCharacteristic[] }>(
    "/api/v0.0.3/client-characteristics"
  );
  return response.data.data;
}

/**
 * POST /api/v0.0.3/client-characteristics
 * Creates a new custom characteristic.
 */
export async function createClientCharacteristic(
  payload: CreateCharacteristicPayload
): Promise<ClientCharacteristic> {
  const response = await apiClient.post<{ data: ClientCharacteristic }>(
    "/api/v0.0.3/client-characteristics",
    payload
  );
  return response.data.data;
}

/**
 * PATCH /api/v0.0.3/client-characteristics/{id}
 * Updates an existing characteristic.
 */
export async function updateClientCharacteristic(
  id: number,
  payload: UpdateCharacteristicPayload
): Promise<ClientCharacteristic> {
  const response = await apiClient.patch<{ data: ClientCharacteristic }>(
    `/api/v0.0.3/client-characteristics/${id}`,
    payload
  );
  return response.data.data;
}

/**
 * DELETE /api/v0.0.3/client-characteristics/{id}
 * Soft-deletes a characteristic and cascades to values.
 */
export async function deleteClientCharacteristic(id: number): Promise<void> {
  await apiClient.delete(`/api/v0.0.3/client-characteristics/${id}`);
}

/**
 * PATCH /api/v0.0.3/client-characteristics/reorder
 * Reorders characteristics by updating sort_order values.
 */
export async function reorderClientCharacteristics(
  items: { id: number; sort_order: number }[]
): Promise<void> {
  await apiClient.patch("/api/v0.0.3/client-characteristics/reorder", { items });
}
